export const initialOrchestratorState = {
  currentIndex: 0,
  isLoading: false,
  navigationContext: {
    skipped: false
  }
};
export function orchestratorReducer(state, action) {
  switch (action.type) {
    case 'NEXT':
      return {
        ...state,
        currentIndex: state.currentIndex + 1,
        navigationContext: {
          skipped: false
        }
      };
    case 'SKIP':
      return {
        ...state,
        currentIndex: state.currentIndex + 1,
        navigationContext: {
          skipped: true
        }
      };
    case 'BACK':
      return {
        ...state,
        currentIndex: Math.max(0, state.currentIndex - 1),
        navigationContext: {
          skipped: false
        }
      };
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: action.payload
      };
    case 'RESET':
      return {
        currentIndex: 0,
        isLoading: false,
        navigationContext: {
          skipped: false
        }
      };
    case 'GO_TO_INDEX':
      return {
        ...state,
        currentIndex: action.payload,
        navigationContext: {
          skipped: false
        }
      };
    default:
      return state;
  }
}
//# sourceMappingURL=reducer.js.map